import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Input from '@material-ui/core/Input';

import axios from 'axios';

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

export default class DeliverReportDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = { open: false, callBack: null, clients: [], client: null, folders: [], folder: null, email: null,copyToMe:true };

        this.handleClientChange = this.handleClientChange.bind(this);
        this.handleFolderChange = this.handleFolderChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
        this.validate = this.validate.bind(this);

        this.handleOkay = this.handleOkay.bind(this);

        this.uploadFile = this.uploadFile.bind(this);
    }

    show(callBack) {
        this.setState({ open: true, callBack: callBack });
    }
    handleClientChange(event) {
        this.setState({ client: event.target.value });

        axios.get('/api/docx/children?parentId=' + event.target.value)
            .then(response => {
                const folders = response.data;
                var folder = null;
                for(var f of folders){
                    if(f.name === 'Assessment Reports'){
                        folder = f.id;
                    }
                }
                this.setState({ folders: folders,folder:folder });
            })
    }
    handleFolderChange(event) {
        this.setState({ folder: event.target.value });
    }
    handleEmailChange(event) {
        this.setState({ email: event.target.value });
    }
    handleFileChange(event) {
        this.setState({ file: event.target.value });
    }
    validate() {
        if (!this.state.client) {
            return "Choose a client to send report";
        }
        if (!this.state.folder) {
            return 'Choose a folder of the client to send report';
        }
        if (!this.state.email) {
            return 'Type email to send notification';
        }
        if (!this.state.file) {
            return 'Choose report file to send';
        }
        const tmp = this.state.file.toUpperCase();
        if (!tmp.endsWith('PDF') && !tmp.endsWith('DOCX')) {
            return 'Report file format should be PDF or MS Word';
        }
        return null;
    }
    uploadFile(file) {
        let data = new FormData();
        data.append('file', file, file.name);
        axios.post('api/docx/uploadReport/' + this.state.folder +'/' + this.state.email,
            data,
            {
                headers: {
                    'accept': 'application/json',
                    'Accept-Language': 'en-US,en;q=0.8',
                    'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
                }
            }
        ).then(response => {
            alert('done');
        }).catch(this.props.showAxiosError);
    }
    handleClose = () => {
        this.setState({ open: false });
        if (this.state.callBack) {
            this.state.callBack(false);
        }
    };

    handleOkay = () => {
        const errorMessage = this.validate();
        if (!errorMessage) {
            this.setState({ open: false });
            this.uploadFile(this.fileInput.files[0]);
            if (this.state.callBack) {
                this.state.callBack(true);
            }
        } else {
            alert(errorMessage);
        }

    };
    componentDidMount() {
        axios.get('/api/docx/clients')
            .then(response => {
                this.setState({ clients: response.data });
            });
    }
    render() {
        return (
            <Dialog
                open={this.state.open}
                TransitionComponent={Transition}
                keepMounted
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title" style={{ marginBottom: '2em' }}>
                    {"Deliver Report"}
                </DialogTitle>
                <DialogContent>
                    <form autoComplete="off">
                        <FormControl>
                            <InputLabel htmlFor="client-simple">Choose Client</InputLabel>
                            <Select style={{ width: '20em', marginLeft: '9em' }}
                                value={this.state.client}
                                onChange={this.handleClientChange}
                                inputProps={{
                                    name: 'client',
                                    id: 'client-simple',
                                }}>
                                {
                                    this.state.clients.map(client => (
                                        <MenuItem key={client.id} value={client.id}>{client.name}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                        <FormControl>
                            <InputLabel htmlFor="folder-simple">Choose Folder</InputLabel>
                            <Select style={{ width: '20em', marginLeft: '9em' }}
                                value={this.state.folder}
                                onChange={this.handleFolderChange}
                                inputProps={{
                                    name: 'folder',
                                    id: 'folder-simple',
                                }}>
                                {
                                    this.state.folders.map(folder => (
                                        <MenuItem key={folder.id} value={folder.id}>{folder.name}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                        <div style={{ display: 'flex' }}>
                            <TextField style={{ flex: '1' }}
                                id="standard-name"
                                label="Send Email To"
                                value={this.state.email}
                                onChange={this.handleEmailChange}
                                margin="normal"
                            />
                            <FormControlLabel style={{marginLeft:'3em',marginTop:'1.5em'}}
                                control={
                                    <Checkbox
                                        checked={this.state.copyToMe}
                                        onChange={event => this.setState({copyToMe: event.target.checked})}
                                        value="copyToMe"
                                        color="primary"
                                    />
                                }
                                label="Copy to Me"
                            />
                        </div>

                        <input type='file' style={{ width: '20em', marginTop: '1.5em' }} ref={ref => this.fileInput = ref} onChange={this.handleFileChange} />

                    </form>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose} color="primary">
                        Cancel
            </Button>
                    <Button onClick={this.handleOkay} color="primary">
                        Ok
            </Button>
                </DialogActions>
            </Dialog>
        );
    }
}